import React from 'react';

import './StandardButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StandardButton = ({ text, icon, onClick, disabled, required, width }) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <button
      style={{ width }}
      disabled={disabled}
      className={required ? 'table-header-button' : 'standard-button'}
      onClick={handleClick}
    >
      {text}
      {icon && (
        <div>
          <FontAwesomeIcon icon={icon} />
        </div>
      )}
    </button>
  );
};
